import { ReactNode } from "react";
import Section from "@/app/features/shared/snap-section/Section";
import SnapSectionsContainer from "@/app/features/shared/snap-section/SnapSectionsContainer";
import { Divider } from "@mui/material";
import styles from "./HistoryViewFrames.module.scss";

export function HistoryViewScrollSnapFrame({ children }: { children: ReactNode }) {
    return (
        <SnapSectionsContainer>
            {children}
        </SnapSectionsContainer>
    );
}

export function HistoryViewIntroFrame({ children, sectionId }: { children: ReactNode; sectionId?: string }) {
    return (
        <Section id={sectionId} className="relative">
            {children}
        </Section>
    );
}

export function HistoryEventSectionFrame({
    children,
    headingId,
    sectionId,
}: {
    children: ReactNode;
    headingId: string;
    sectionId: string;
}) {
    return (
        <>
            <Section id={sectionId} aria-labelledby={headingId} className="relative">
                {children}
            </Section>
            <div className={styles.dividerWrapper}>
                <Divider className={styles.divider} />
            </div>
        </>
    );
}
